import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "students",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "school-teacherSetup" */ "./StudentSetup"),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "SchoolSetup/modules/SchoolSetupModule"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "ResetInviteAndSignInCodeModal/modules/ResetInviteAndSignInCodeModalModule"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "StudentSetup/modules/StudentsModule"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "StudentSetup/components/CreateStudent/containers/CreateStudentModule"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "StudentSetup/components/EditStudent/containers/StudentDetailsModule"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "StudentSetup/components/BulkActionsModal/modules/BulkActionsModalModule"
      ),
      import(
        /* webpackChunkName: "course-manage-family" */ "Course/routes/ManageFamily/modules/ManageFamilyModule"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "StudentSetup/components/BulkActions/modules/BulkActionsModule"
      ),
    ]).then(
      ([
        importedModule0,
        importedModule1,
        importedModule2,
        importedModule3,
        importedModule4,
        importedModule5,
        importedModule6,
        importedModule7,
        importedModule8,
      ]) => {
        const component = importedModule0.default;
        const schoolSetupReducer = importedModule1.default;
        const resetInviteAndSignInCodeModalModule = importedModule2.default;
        const createStudentModule = importedModule4;
        const studentDetailsModule = importedModule5;
        const studentBulkActionsModule = importedModule6;
        const bulkActionsModule = importedModule8;

        injectReducer(store, {
          key: "schoolSetup",
          reducer: schoolSetupReducer,
        });

        injectReducer(store, {
          key: "resetInviteAndSignInCodeModal",
          reducer: resetInviteAndSignInCodeModalModule,
        });

        injectReducer(store, {
          key: importedModule3.NAME,
          reducer: importedModule3.default,
        });

        injectReducer(store, {
          key: createStudentModule.NAME,
          reducer: createStudentModule.default,
        });

        injectReducer(store, {
          key: studentDetailsModule.NAME,
          reducer: studentDetailsModule.default,
        });

        injectReducer(store, {
          key: studentBulkActionsModule.NAME,
          reducer: studentBulkActionsModule.default,
        });

        injectReducer(store, {
          key: "manageFamily",
          reducer: importedModule7.default,
        });
        injectReducer(store, {
          key: bulkActionsModule.NAME,
          reducer: bulkActionsModule.default,
        });

        return component;
      }
    )
  ),
  childRoutes: [],
});
